module.exports = __webpack_public_path__ + "static/media/like@3x.f35f10ab.png";